import { FetchLookupsResponse } from '@lib/api';

import { getBranchesAddressFromLookupsResponse } from './getBranchesAddressFromLookupsResponse';
import { getExpectedHandlingWaitingTimeFromLookupsResponse } from './getExpectedHandlingWaitingTimeFromLookupsResponse';
import { getFirestoreNewOrdersQueryFromLookupsResponse } from './getFirestoreNewOrdersQueryFromLookupsResponse';
import { getFirestoreOrderQueryFromLookupsResponse } from './getFirestoreOrderQueryFromLookupsResponse';
import { getRejectedReasonFromLookupsResponse } from './getRejectedReasonFromLookupsResponse';
import { getRestaurantLogoUrlFromLookupsResponse } from './getRestaurantLogoUrlFromLookupsResponse';
import { getRestaurantNameFromLookupsResponse } from './getRestaurantNameFromLookupsResponse';

import { LookupsValue } from '../types';

export function fromLookupsResponseToLookupsValue(
  lookupsResponse: FetchLookupsResponse,
): LookupsValue {
  const { expectedWaitingTime, expectedHandlingTime } =
    getExpectedHandlingWaitingTimeFromLookupsResponse(lookupsResponse);

  return {
    expectedWaitingTime,
    expectedHandlingTime,
    userCode: lookupsResponse.userCode,
    userUUID: lookupsResponse.userUUID,
    restaurantPhotoUrl:
      getRestaurantLogoUrlFromLookupsResponse(lookupsResponse),
    restaurantName: getRestaurantNameFromLookupsResponse(lookupsResponse),
    query: getFirestoreNewOrdersQueryFromLookupsResponse(lookupsResponse),
    orderQuery: getFirestoreOrderQueryFromLookupsResponse(lookupsResponse),
    rejectionReasons: getRejectedReasonFromLookupsResponse(lookupsResponse),
    branchesAddress: getBranchesAddressFromLookupsResponse(lookupsResponse),
  };
}
